var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Component 137 \\u2013 9"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Share Black"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 32582",
    d: "M14.974 14.237a.752.752 0 010-1.062L17.44 10.7H6.2V9.2h11.242l-2.469-2.473a.751.751 0 111.062-1.062l3.746 3.755a.753.753 0 010 1.064l-3.744 3.753a.75.75 0 01-1.063 0zM1.516 19h9.378a1.517 1.517 0 001.516-1.518V11.8h-1.5v5.7H1.5v-15h9.41v5.656h1.5V2.518A1.517 1.517 0 0010.894 1H1.516A1.517 1.517 0 000 2.518v14.964A1.517 1.517 0 001.516 19z"
  })))));
}

export default SvgShare;